import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=70be51fc&scoped=true"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=70be51fc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70be51fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70be51fc')) {
      api.createRecord('70be51fc', component.options)
    } else {
      api.reload('70be51fc', component.options)
    }
    module.hot.accept("./Confirm.vue?vue&type=template&id=70be51fc&scoped=true", function () {
      api.rerender('70be51fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/src/componentsUI/confirm/Confirm.vue"
export default component.exports